import Button from 'components/Button';
import { ArrowRightIcon } from 'components/icons';
import Link from 'components/Link';
import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StatsCard = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.grey200};
  border-radius: 8px;
  overflow: hidden;
`;

export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey200};

  &:last-of-type {
    border-bottom: 0;
  }
`;

export const StatCell = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.5rem 0.75rem;
  border-right: 1px solid ${({ theme }) => theme.colors.grey200};
  text-decoration: none;

  &:hover {
    background-color: ${({ theme }) => theme.colors.grey200};
  }

  &:last-child {
    border-right: 0;
  }
`;

export const StatNumber = styled.span`
  color: ${({ theme }) => theme.colors.accent};
  font-size: 1rem;
  font-weight: ${({ theme }) => theme.weights.semiBold};
  line-height: 1;
  text-align: left;
`;

export const StatLabel = styled.span`
  color: ${({ theme }) => theme.colors.black};
  font-size: 0.625rem;
  font-weight: ${({ theme }) => theme.weights.semiBold};
  letter-spacing: 0.03em;
  line-height: 1;
  text-align: left;
  text-transform: uppercase;
`;

export const Footer = styled.div`
  display: flex;
`;

export const ActivityButton = styled(Button)`
  && {
    align-self: flex-start;
    align-items: center;
    width: fit-content;
    gap: 0.25rem;
    padding: 0.5rem 0.75rem;
  }
`;

export const ButtonArrow = styled(ArrowRightIcon)`
  width: 1.25rem;
  height: 1.25rem;
`;
